import React, { useState } from 'react';
import { FormHelperText, HStack, Button } from '@chakra-ui/react';

export default function DescriptionPreview({ description }) {
    const [showFull, setShowFull] = useState(false);

    const toggleShow = () => setShowFull(!showFull);

    const isLong = description.length > 100;
    const previewText = showFull ? description : description.slice(0, 100);

    return (
        < >
            <FormHelperText>
                {previewText}
                {isLong && !showFull && '...'}

            </FormHelperText>
            {isLong && (
                <Button fontSize="sm" onClick={toggleShow} style={{ textDecoration: 'underline', background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
                    {showFull ? 'Show less' : 'Show all'}
                </Button>
            )}
            </>
    );
}
